/* eslint-disable indent */
import {
    useCallback, useEffect, useRef, useState,
} from 'react';
import luminaEnv from 'src/env';
import { decodedToken } from 'src/graphql';
import { decodeKeycloakToken } from 'src/utils/tokenProcess';
// import axios from "axios";

type Props = {
    shouldStart: boolean;
    setError: (error: Error) => void;
};

const KeycloakAuth = (props: Props) => {
    const { shouldStart, setError } = props;

    const [iframeSrc] = useState(`${luminaEnv.ssoV2Url}/auth-frame`);
    const iframeRef = useRef<HTMLIFrameElement | null>(null);

    const ssoV2IframeListener = useCallback(
        (event: MessageEvent) => {
            if (!shouldStart) return;

            if (
                event.origin !== luminaEnv.ssoV2Url
                && typeof event.data !== 'string'
            ) {
                return;
            }

            try {
                const ssoData = JSON.parse(event.data);

                if ('error' in ssoData && ssoData.error) {
                    throw new Error(ssoData.error);
                }

                switch (ssoData.method) {
                    case 'init': {
                        iframeRef.current?.contentWindow?.postMessage(
                            JSON.stringify({ method: 'request-token' }),
                            luminaEnv.ssoV2Url
                        );
                        break;
                    }
                    case 'set-token':
                    case 'refresh-token': {
                        let isLoggedInKeycloak = false;
                        if (ssoData.data !== null && ssoData.data !== 'null') {
                            localStorage.setItem('id_token', ssoData.data);

                            const profile = decodeKeycloakToken(ssoData.data);
                            if (profile !== null) {
                                localStorage.setItem(
                                    'profile',
                                    JSON.stringify(profile)
                                );
                                decodedToken(profile);

                                localStorage.setItem('ssoVersion', '2');
                                isLoggedInKeycloak = true;

                                if (ssoData.method === 'set-token') {
                                    setInterval(async () => {
                                        // Request token every 15 minutes to refresh keycloak token
                                        iframeRef.current?.contentWindow?.postMessage(
                                            JSON.stringify({ method: 'request-refresh-token' }),
                                            luminaEnv.ssoV2Url
                                        );
                                    }, (1000 * 60 * 15));
                                }
                            }
                        }

                        if (!isLoggedInKeycloak) {
                            localStorage.removeItem('ssoVersion');
                            localStorage.removeItem('id_token');
                            // Auth0 auth.
                            setError(new Error('Logged out from Keycloak'));
                        }
                        break;
                    }
                    default: {
                        break;
                    }
                }
            } catch (e: unknown) {
                console.log(e);
                if (e instanceof Error) {
                    setError(e);
                }
            }
        },
        [shouldStart, setError]
    );

    useEffect(() => {
        window.addEventListener('message', ssoV2IframeListener);

        return () => {
            window.removeEventListener('message', ssoV2IframeListener);
        };
    }, [ssoV2IframeListener]);

    return (
        <iframe
            id='sso-iframe'
            title='SSO Iframe'
            src={iframeSrc}
            ref={iframeRef}
            style={{ display: 'none' }}
        ></iframe>
    );
};

export default KeycloakAuth;
